/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:da78306c-1010-45c2-891b-ff39b4afc32c",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_1g3ZrJM0T",
    "aws_user_pools_web_client_id": "4iper4dn33447ea09o1tibk6hr",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "amplifysolar05c28e3aa82b7a41d9bef2b57aeb702074679c7-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
